<template>
  <svg id="waste-container" width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 2V1H6V2H5V4H6.46L10.17 31H22.48C22.48 31 22.18 31 22.49 31C24.98 31 26.99 28.99 26.99 26.5C26.99 24.54 25.74 22.87 23.99 22.26V4H26.99V2H24ZM18.76 29C18.28 28.28 18 27.43 18 26.5C18 24.18 19.75 22.28 22 22.03V4H8.48L11.91 29H18.76ZM25 26.5C25 27.88 23.88 29 22.5 29C21.12 29 20 27.88 20 26.5C20 25.12 21.12 24 22.5 24C23.88 24 25 25.12 25 26.5Z"
      fill="var(--fg-color, #2A2859)"
    />
  </svg>
</template>

<script>
export default {
  name: 'OdsWasteContainer',
};
</script>
